import { trackSmartMetric } from './trackSmartMetric';

const trackComboImpression = () => {
  trackSmartMetric('month_view_combo_recommendation_impression');
};

const trackComboClick = (element: string) => {
  trackSmartMetric(`month_view_combo_recommendation_${element}_clicked`);
};

export { trackComboClick, trackComboImpression };
